import { memo } from 'react'

import { T } from 'govwell-ui'

import { parseOpenSearchEmSnippet } from 'src/utils/parseOpenSearchEmSnippet'

type Props = {
  snippet: string
}

/** Shared body for universal search plan page rows (OpenSearch `<em>` highlights). */
const UniversalSearchPlanPageResultBody = ({ snippet }: Props) => {
  return <T.Body>{parseOpenSearchEmSnippet(snippet)}</T.Body>
}

export default memo(UniversalSearchPlanPageResultBody)
